import axios from 'axios'
import env from '@env'
import ormTransform from './ormTransform'
import { storeMobx } from 'restaurant'

export default class StoreAPI {
  static getSort () {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({
          products: [2, 3, 4, 1],
          categories: [1, 2]
        })
      }, 0)
    })
  }
  /**
   * 获取门店的桌台详情
   * @param {number} storeId - 门店id
   * @param {number} [brandId=BRANDID] - 品牌id
   */
  static async getTable (storeId?: number) {
    const url = `${env.POSMOBILE}/storeDesk/allDesk`
    const params = {
      brandId: storeMobx.info.brandId,
      storeId: storeId || storeMobx.info.storeId
    }
    return await axios.post(url, params).then((res: any) => {
      if (res.result && res.result.content) {
        // list => tables
        const theContent = res.result.content
        theContent.forEach((content: any) => {
          content.storeDesks = content.list
          delete content.list
        })
        const transArea = ormTransform.clearKey(res.result.content, 'storeDeskArea')
        return transArea
      }
    }).catch((err) => err)
  }

  /** 获取门店数据  这个方法现在是不通的 */
  static getStore (brandId: number) {
    const url = `${env.POSMOBILE}/store/listStore`
    return axios.post(url, {
      brandId
    }).then((res: any) => {
      return res.result.content[0]
    })
  }

  /** 获取门店数据  这个方法现在是不通的 */
  static async getStoreList (params: { cityName?: string }) {
    const url = `${env.JMOBILE}/mobileHomePage/getStoreInfo`
    const res: any = await axios.post(url, params)
    return res.error ? res : res.result
  }

  /** 获取所有场景 */
  static async getScenes () {
    const url = `${env.JMOBILE}/serviceMode/scenes`
    const res: any = await axios.get(url)
    return res.error ? res : res.result
  }

  /** 获取品牌下所有门店手机场景 */
  static async getMobileServiceModes () {
    const url = `${env.JMOBILE}/serviceMode/getMobileServiceModes`
    const res: any = await axios.post(url)
    return res.error ? res : res.result
  }

  static async getStoreByMember (params: { memberId: string | number; startTime: string; endTime: string }) {
    const url = `${env.REPORT}/report/jl-base-member-order/`
    return axios.post(url, { params }).then((data: any) => {
      if (data?.result) {
        return data?.result
      } else {
        throw data
      }
    })
  }

  /**
   * 获取首页进入信息
   * @param {number} [brandId=BRANDID] - 品牌id
   * @desc 扫品牌码：只有brandId则返回品牌所有门店
   * @param {number} [storeId] - 门店id
   * @desc 扫门店码：有brandId和storeId返回当前门店信息
   * @param {string} [memberId] - 用户登陆以后有
   * @desc 有memberId则返回门店消费统计
   * @param {number} lbsLng - 经度
   * @param {number} lbsLat - 纬度
   * @desc lbsLng和lbsLat不传则无距离信息
   * @returns {Promise<TError & IHomePageRes >}
   */
  // static async getHomePage (params: { brandId: number; storeId?: number; memberId?: string; lbsLng?: number; lbsLat?: number }): Promise<TError & IHomePageRes> {
  //   params = {
  //     ...params
  //   }
  //   !params.storeId && delete params.storeId
  //   const res = await axios.post(env.POSMOBILE + '/homePage/homePage', params).catch((error) => error)
  //   return res.error ? res : res.result
  // }
  // : Promise<TError & IHomePageRes>
  static async getHomePage (params: { brandId: number; storeId?: number}) {
    params = {
      ...params
    }
    !params.storeId && delete params.storeId
    const res = await axios.post(env.JMOBILE + '/mobileHomePage/homePage', params).catch((error) => error)
    return res.error ? res : res.result
  }

  static async getSaleCount (brandId: number) {
    const res = await axios.post(env.JMOBILE + '/mobileHomePage/getSaleCount', { brandId }).catch((error) => error)
    if (res && res.result) {
      return res.result
    } else {
      throw res
    }
  }

  /** 获取餐品制作时间 */
  static getMealsWaitingTime (storeId: number, brandId?: number, ordersId?: string) {
    const url = `${env.JMOBILE}/selfDelivery/getMealsWaitingTime`
    const params = {
      storeId,
      ordersId,
      brandId
    }
    return axios.get(url, { params }).then((data: any) => {
      if (data?.result) {
        return data?.result
      } else {
        return {}
      }
    })
  }

  /**
   * 呼叫服务员
   * @param {number} storeId - 门店id
   * @param {string} tableCode - 桌码
   * @param {string} tableAlias - 桌名
   * @param {string} content - 文字内容
   */
  static async sendServiceRing (params: { storeId: number; tableCode: string; tableAlias: string; content?: string }) {
    const res = await axios.post(`${ENV.ORDER}/sendServiceRing`, params).catch((error) => error)
    return res?.result === 'success'
  }
  static async updateStoreExt (params: any) {
    return Promise.reject(false)
  }
}
